{
  "title": "Portfolio Trading Hub",
  "titleV2": "Portfolio Trading Hub v2",
  "tabs": {
    "dashboard": "Dashboard",
    "portfolios": "Portfolios",
    "trades": "Trades",
    "activeOperations": "Active Operations"
  },
  "relativeTime": {
    "justNow": "just now",
    "minutesAgo": "{{count}}m ago",
    "hoursAgo": "{{count}}h ago",
    "daysAgo": "{{count}}d ago",
    "updated": "Updated {{time}}"
  },
  "insights": {
    "title": "Insights",
    "closeA11y": "Close insights",
    "toggleA11y": "Toggle Insights",
    "sections": {
      "alerts": "Alerts",
      "suggestions": "Suggestions",
      "info": "Info"
    },
    "footer": {
      "poweredBy": "Powered by rules engine"
    },
    "driftAlert": {
      "title_one": "{{count}} portfolio needs attention",
      "title_other": "{{count}} portfolios need attention",
      "description": "{{percent}}% of portfolios have drift beyond tolerance, pending liquidations, or transfer rebalances. Prioritize these before end of day.",
      "action": "View flagged portfolios"
    },
    "opsActive": {
      "title_one": "{{count}} operation in progress",
      "title_other": "{{count}} operations in progress",
      "description": "Active rebalances or trade batches are processing. Check for any that may be stuck in an intermediate state.",
      "action": "Monitor active operations"
    },
    "tradesInFlight": {
      "title_one": "{{count}} trade in pipeline",
      "title_other": "{{count}} trades in pipeline",
      "descriptionBulk": "Large batch of {{count}} trades active. Review for stale INITIATED entries.",
      "descriptionDefault": "Trades are progressing through the pipeline. Check for any blocked or stale entries.",
      "action": "View in-flight trades"
    },
    "cashFlowRisk": {
      "title_one": "{{count}} outflow at overdraft risk",
      "title_other": "{{count}} outflows at overdraft risk",
      "description": "Pending withdrawals exceeding 90% of portfolio value. Could cause overdrafts or forced liquidations.",
      "action": "Review cash flows"
    },
    "cashFlowImminent": {
      "title_one": "{{count}} cash event due within 24h",
      "title_other": "{{count}} cash events due within 24h",
      "description": "Transfers scheduled for today or tomorrow. Verify sufficient liquidity and no conflicting trades.",
      "action": "Review cash flows"
    },
    "cashFlowOverview": {
      "title_one": "{{count}} pending cash flow",
      "title_other": "{{count}} pending cash flows",
      "description": "{{inflows}}, {{outflows}}. {{outflowAmount}} total pending outflows. No immediate risk.",
      "descriptionInflows_one": "{{count}} inflow",
      "descriptionInflows_other": "{{count}} inflows",
      "descriptionOutflows_one": "{{count}} outflow",
      "descriptionOutflows_other": "{{count}} outflows",
      "action": "View details"
    },
    "allClear": {
      "title": "All systems nominal",
      "description_one": "{{count}} portfolio within tolerance. No active operations or pending trades.",
      "description_other": "{{count}} portfolios within tolerance. No active operations or pending trades."
    },
    "bulkOptimize": {
      "title": "Consider bulk optimization",
      "description": "{{count}} portfolios need rebalancing with no active operations. Use bulk select to optimize in one batch.",
      "action": "Select portfolios"
    },
    "settlementCheck": {
      "title": "Review settlement dates",
      "description": "Trades in pipeline with no active operations. Verify settlement dates are correct.",
      "action": "Check trades"
    }
  },
  "bulkTradeRunStates": {
    "GENERATING": "Preparing trades...",
    "BULK_TRADES_INITIATED": "Ready for review",
    "BULK_TRADES_FILES_GENERATING": "Generating trade files...",
    "BULK_TRADES_REQUESTED": "Processing...",
    "BULK_TRADES_COMPLETED": "Ready to allocate",
    "ALLOCATIONS_INITIATED": "Preparing allocations...",
    "ALLOCATIONS_REQUESTED": "Processing allocations...",
    "ALLOCATIONS_COMPLETED": "Allocations ready",
    "COMPLETED": "Complete",
    "COMPLETED_PENDING_PTFS": "PTF trades pending",
    "CANCELED": "Canceled"
  },
  "todaysDashboard": {
    "title": "Dashboard"
  },
  "snapshotCards": {
    "needsAction": {
      "title": "Needs Action",
      "secondaryStat": "{{count}} on track",
      "breakdown": {
        "urgent": "Liquidate / Transfer",
        "moderate": "Drift / Unverified",
        "aum": "AUM"
      }
    },
    "tradePipeline": {
      "title": "Trade Pipeline",
      "secondaryStat": "pending trades",
      "breakdown": {
        "staged": "Staged",
        "approved": "Approved",
        "sent": "Sent"
      }
    },
    "opsInFlight": {
      "title": "Ops In Flight",
      "secondaryStat": "operations",
      "breakdown": {
        "rebalances": "Rebalances",
        "batches": "Batches"
      }
    }
  },
  "tradePipeline": {
    "title": "Trade Pipeline",
    "asOfPrefix": "As of",
    "viewTrades": "View trades →",
    "totalOutstanding": "TRADE FLOW — {{total}} TOTAL OUTSTANDING",
    "errorPrefix": "Error:",
    "emptyBar": "No trades outstanding",
    "staged": {
      "title": "Staged",
      "description": "Awaiting approval"
    },
    "approved": {
      "title": "Approved",
      "description": "Ready to send"
    },
    "sent": {
      "title": "Sent",
      "description": "Submitted to custodians"
    }
  },
  "operations": {
    "activeTitle": "ACTIVE OPERATIONS ({{count}})",
    "emptyTitle": "No active operations",
    "emptyDescription": "Rebalances and trade batches will appear here when in flight",
    "optimizerPortfolios": "{{count}} portfolios",
    "bulkTradeRun": "Bulk Trade Run"
  },
  "deepLink": {
    "missingObjectId": "This portfolio could not be fully loaded — detail data may be incomplete."
  },
  "filters": {
    "searchPortfolios": "Search portfolios...",
    "searchTickers": "Search tickers...",
    "searchModels": "Search models...",
    "allStatuses": "All Reasons",
    "needsRebalance": "Needs Rebalance",
    "drift": "Drift",
    "transfer": "Transfer",
    "liquidation": "Liquidation",
    "trading": "Trading",
    "allTypes": "All Types",
    "goals": "Goals",
    "subAccounts": "Sub-Accounts",
    "allModels": "All Models",
    "modelSearchPlaceholder": "Search models...",
    "modelSearchFailed": "Model search failed. Please try again.",
    "portfolioSearchFailed": "Portfolio search failed. Please try again.",
    "exposureSearchFailed": "Ticker search failed. Please try again.",
    "clear": "Clear",
    "downloadAllSelected": "Download All Selected",
    "rebalanceStarted_one": "Started rebalancing {{count}} portfolio. View progress in Active Operations tab.",
    "rebalanceStarted_other": "Started rebalancing {{count}} portfolios. View progress in Active Operations tab.",
    "optimizePartialSuccess": "{{succeeded}} of {{total}} optimizations started; {{failed}} failed.",
    "optimizeAllFailed": "All optimizations failed. Please try again."
  },
  "portfoliosTable": {
    "columns": {
      "portfolio": "Portfolio",
      "modelName": "Model Name",
      "reason": "Reason",
      "custodian": "Custodian",
      "advisor": "Advisor",
      "value": "Value",
      "cashAndPosition": "Band Consumed",
      "lastRebalDate": "Last Rebal Date",
      "trades": "Trades"
    },
    "custodian": {
      "multiple": "Multiple"
    },
    "advisor": {
      "multiple": "Multiple"
    },
    "cashPosition": {
      "cash": "Cash",
      "position": "Position"
    },
    "tradeToasts": {
      "created_one": "{{count}} trade created successfully. View them in the Trades tab.",
      "created_other": "{{count}} trades created successfully. View them in the Trades tab.",
      "createFailed": "Failed to create trades. Please try again.",
      "noActionable": "No actionable trades — all selected positions are already at or near target.",
      "missingGoalObjectId_one": "{{count}} goal portfolio was skipped because its account ID is missing.",
      "missingGoalObjectId_other": "{{count}} goal portfolios were skipped because their account IDs are missing.",
      "createPartialSuccess": "{{succeeded}} of {{total}} trade groups created; {{failed}} failed.",
      "createAllFailed": "Failed to create all trades. Please try again.",
      "bucketPartialFailure_one": "{{count}} portfolio failed to bucket its new trades.",
      "bucketPartialFailure_other": "{{count}} portfolios failed to bucket their new trades."
    },
    "pageLoadErrorTitle": "This page failed to load.",
    "pageLoadErrorDescription": "The backend returned a GraphQL non-null violation for one or more rows on page {{page}}, so the entire page payload was dropped. Other pages may still work.",
    "retryThisPage": "Retry this page",
    "goBackPage": "Go back a page",
    "noPortfoliosFound": "No portfolios found.",
    "adjustFiltersHint": "Try adjusting your filters.",
    "noDataAvailable": "No data available.",
    "unresolvedRows_one": "{{count}} portfolio on this page could not be loaded.",
    "unresolvedRows_other": "{{count}} portfolios on this page could not be loaded."
  },
  "portfoliosTab": {
    "fatalError": "Error loading portfolios: {{message}}"
  },
  "download": {
    "button": "Download CSV",
    "all": "Download All",
    "withFilters": "Download with Filters",
    "filtersTooltip": "Search filters are not applied",
    "progressTitle": "Exporting portfolios",
    "fileNamePrefix": "portfolio-reports",
    "exportHeaders": {
      "portfolioId": "Portfolio ID",
      "type": "Type",
      "modelPortfolio": "Model Portfolio",
      "marketValue": "Market Value",
      "cashAvailable": "Cash Available",
      "targetCashPercent": "Target Cash %",
      "status": "Status",
      "driftRequired": "Drift Required",
      "pendingTrades": "Pending Trades",
      "lastOptimized": "Last Optimized"
    }
  },
  "modelPortfolioView": {
    "columns": {
      "model": "Model",
      "portfolios": "# of Portfolios",
      "marketValue": "Total Value",
      "avgDrift": "Average Drift",
      "rebalance": "Rebalance",
      "trades": "Trades",
      "currency": "Currency"
    }
  },
  "tickerView": {
    "columns": {
      "security": "Security",
      "totalValue": "Total Value",
      "totalQty": "Total Qty",
      "portfolios": "# of Portfolios",
      "pctAum": "% of AUM",
      "currency": "Currency"
    }
  },
  "rowDetail": {
    "header": {
      "noModel": "No Model",
      "goalTypeSuffix": " • {{type}}",
      "subAccountTypeSuffix": " • {{accountType}} (Tax Rank: {{taxRank}})",
      "multiCcy": "Multi-CCY ({{currencies}})",
      "updatedAt": "As of {{date}}"
    },
    "generalInfo": {
      "title": "General Info",
      "marketValue": "Market Value",
      "cash": "Cash",
      "targetCash": "Target Cash",
      "drift": "Drift",
      "pending": "Pending",
      "holdings": "Holdings",
      "none": "None",
      "staleActiveTrades": "0 active (report: {{count}} stale)",
      "activeTradesCount": "{{count}} trades",
      "driftExceedsThreshold": "Exceeds threshold",
      "driftMonitor": "Monitor",
      "driftWithinTolerance": "Within tolerance",
      "positionsCount": "{{count}} positions"
    },
    "accountBreakdown": {
      "title": "Account Breakdown ({{count}})",
      "type": "Type",
      "client": "Client",
      "marketValue": "Market Value",
      "cashAvailable": "Cash Available",
      "pendingWithdraw": "Pending Withdraw"
    },
    "pendingTrades": {
      "title": "Pending Trades",
      "titleWithCount": "Pending Trades ({{count}})",
      "noActiveTrades": "No active trades found",
      "staleCountWarning": "Report shows {{count}} pending — this count is stale. Trades may have been cancelled, completed, or reconciled since the last portfolio refresh.",
      "side": "Side",
      "security": "Security",
      "amount": "Amount",
      "qty": "Qty",
      "state": "State",
      "created": "Created",
      "buyCount_one": "{{count}} Buy",
      "buyCount_other": "{{count}} Buys",
      "sellCount_one": "{{count}} Sell",
      "sellCount_other": "{{count}} Sells",
      "net": "Net: {{value}}"
    },
    "positions": {
      "title": "Positions ({{count}})",
      "symbol": "Symbol",
      "currency": "CCY",
      "qty": "Qty",
      "price": "Price",
      "value": "Value",
      "currentPct": "Curr %",
      "targetPct": "Tgt %",
      "drift": "Drift",
      "driftValue": "Drift $"
    },
    "actions": {
      "viewDetails": "View Details",
      "generateTrades": "Generate Trades"
    }
  }
}
